"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalProductDeletedContract = exports.ExternalProductUpdatedContract = exports.ExternalProductCreatedContract = exports.ExternalProductEventDataContract = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const events_1 = require("@getgreenline/events");
class ExternalProductEventDataContract {
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "shortName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)({ name: 'parentProductId' }),
    (0, class_transformer_1.Transform)((val) => {
        return val.value ? { id: val.value } : null;
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "parentProduct", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)({ name: 'categoryId' }),
    (0, class_transformer_1.Transform)((val) => {
        return val.value ? { id: val.value } : null;
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)({ name: 'supplierId' }),
    (0, class_transformer_1.Transform)((val) => {
        return val.value ? { id: val.value } : null;
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "supplier", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "shortDescription", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "barcode", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "sku", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalProductEventDataContract.prototype, "imageUrl", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "isMasterProduct", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "isDeleted", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((data) => {
        return {
            retailPrice: data.obj.price || null,
            wholesaleCost: data.obj.wholesaleCost || null,
        };
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "prices", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((data) => {
        return {
            weight: data.obj.weight || null,
            cannabisWeight: data.obj.cannabisWeight || null,
            cannabisVolume: data.obj.cannabisVolume || null,
        };
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "measurements", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)({ name: 'taxGroupId' }),
    (0, class_transformer_1.Transform)((val) => {
        return val.value ? { id: val.value } : null;
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "tax", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)({ name: 'depositFee' }),
    (0, class_transformer_1.Transform)((val) => {
        return { deposit: val.value || null };
    }),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "fees", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ExternalProductEventDataContract.prototype, "metaData", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "trackInventory", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "isBatchTracked", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || false),
    __metadata("design:type", Boolean)
], ExternalProductEventDataContract.prototype, "isGiftCard", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ExternalProductEventDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ExternalProductEventDataContract.prototype, "updateDate", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || []),
    __metadata("design:type", Array)
], ExternalProductEventDataContract.prototype, "cannabinoidMetaData", void 0);
exports.ExternalProductEventDataContract = ExternalProductEventDataContract;
class ExternalProductCreatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ExternalProductEventDataContract, params.product);
    }
}
exports.ExternalProductCreatedContract = ExternalProductCreatedContract;
class ExternalProductUpdatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ExternalProductEventDataContract, params.product);
    }
}
exports.ExternalProductUpdatedContract = ExternalProductUpdatedContract;
class ExternalProductDeletedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.product = events_1.GreenlineEvent.create(ExternalProductEventDataContract, params.product);
    }
}
exports.ExternalProductDeletedContract = ExternalProductDeletedContract;
//# sourceMappingURL=products.js.map